import { Link } from "react-router-dom";
import { categories, siteInfo } from "@/mocks/gossipData";

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="w-full bg-secondary-950 text-background-100">
      <div className="px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <Link to="/" className="flex items-center gap-3 cursor-pointer">
              <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-accent-500 text-secondary-950">
                <i className="ri-leaf-line text-xl" aria-hidden="true" />
              </span>
              <span className="font-heading text-2xl text-background-50">{siteInfo.name}</span>
            </Link>
            <p className="mt-5 max-w-md text-sm leading-relaxed text-background-200">
              {siteInfo.slogan}。我们专注娱乐与网络热点的整理与盘点，覆盖综艺、剧集、音乐、时尚与赛场内容。
            </p>
            <p className="mt-5 flex items-center gap-2 text-sm text-background-200">
              <i className="ri-mail-line" aria-hidden="true" />
              <a
                href={`mailto:${siteInfo.email}`}
                className="transition-colors hover:text-accent-400 cursor-pointer"
              >
                {siteInfo.email}
              </a>
            </p>
          </div>

          <nav aria-label="内容分类" className="md:col-span-3">
            <h4 className="font-heading text-lg text-background-50">
              <Link to="/gossip" className="cursor-pointer transition-colors hover:text-accent-400">
                内容分类
              </Link>
            </h4>
            <ul className="mt-5 flex flex-col gap-3 text-sm">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/gossip?category=${cat.slug}`}
                    className="text-background-200 transition-colors hover:text-accent-400 cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <nav aria-label="站点导航" className="md:col-span-2">
            <h4 className="font-heading text-lg text-background-50">站点</h4>
            <ul className="mt-5 flex flex-col gap-3 text-sm">
              <li>
                <Link
                  to="/"
                  className="text-background-200 transition-colors hover:text-accent-400 cursor-pointer"
                >
                  首页
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-background-200 transition-colors hover:text-accent-400 cursor-pointer"
                >
                  关于我们
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-background-200 transition-colors hover:text-accent-400 cursor-pointer"
                >
                  联系我们
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-background-200 transition-colors hover:text-accent-400 cursor-pointer"
                >
                  选题投稿
                </Link>
              </li>
            </ul>
          </nav>

          <div className="md:col-span-2">
            <h4 className="font-heading text-lg text-background-50">更新说明</h4>
            <p className="mt-5 text-sm leading-relaxed text-background-200">{siteInfo.updateFreq}</p>
            <p className="mt-3 text-sm leading-relaxed text-background-200">{siteInfo.replyTime}</p>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-secondary-800 pt-6 text-xs text-background-300 sm:flex-row sm:items-center sm:justify-between">
          <p>
            © {year} {siteInfo.name}. 内容仅供信息整理与交流参考。
          </p>
          <p className="flex flex-wrap items-center gap-x-4 gap-y-1">
            <span>本站内容为编辑整理，如涉版权请来信告知</span>
          </p>
        </div>
      </div>
    </footer>
  );
}